import WsService from "./WsService";
import Customer from "../domain/Customer";
import MsisdnSearchStripper from "../utils/MsisdnSearchStripper";
import CustomerDTO from "../domain/CustomerDTO";

const ENDPOINT_BASE = "/admin/customer";

export default class CustomerService {

    static retrieveCustomer(idNumber, phoneNumber) {

        let endpoint = ENDPOINT_BASE + "?first-name=&last-name=&id-number=" + idNumber + "&msisdn=" + MsisdnSearchStripper.stripMsisdn(phoneNumber);

        return WsService.get(endpoint, {}, 200).then(
            response => {
                if (response.length === 1 && Array.isArray(response)) {
                    return new Customer(response[0]);
                }
                else {
                    return response;
                }
            });
    }

    static retrieveCustomerByRegistrationId(registrationId){

        let endpoint = ENDPOINT_BASE + "/" + registrationId;

        return WsService.get(endpoint, {}, 200).then(
            response => {
                if(response["registration-id"]) {
                    return new CustomerDTO(response);
                }
                else{
                    return response;
                }
            }
        )

    }

}
